import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Layout from '../components/Layout';
import moment from "moment-timezone";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome } from '@fortawesome/free-solid-svg-icons';
import { Col, Row, Breadcrumb, Container } from '@themesberg/react-bootstrap';
import {
  BannerHeading,
  BannerContainer,
  CourseCard,
  CourseTitle,
  CourseDescription,
} from "../components/services/ServicesElements";
import Image from "../images/jobs.svg"; 
import InfoSectionLight from "../components/coursesSection";
import { BASE_URL } from "../constants";
const JobsScreen = () => {
  const navigate = useNavigate();
  const [jobs, setJobs] = useState([]);

<BannerContainer>
  <BannerHeading>Available Jobs</BannerHeading>

  {Array.isArray(jobs) && jobs.length > 0 ? (
    <Row xs={1} sm={2} md={3} lg={4} xl={3} className="g-4 justify-content-center">
      {jobs.map((job) => (
        <Col key={job._id} className="d-flex justify-content-center">
          <CourseCard className="course-card p-3 border rounded-3 d-flex flex-column h-100">
            <CourseTitle>{job.title}</CourseTitle>
            <CourseDescription>{job.description}</CourseDescription>
            <p><strong>Company:</strong> {job.company}</p>
            <p>
              <strong>Job Link:</strong>{" "}
              <a href={job.link} target="_blank" rel="noopener noreferrer">
                {job.link}
              </a>
            </p>
            <p><strong>Type:</strong> {job.type}</p>
            <p><strong>Requirements:</strong> {job.requirements.join(', ')}</p>
          </CourseCard>
        </Col>
      ))}
    </Row>
  ) : (
    <p className="text-center mt-4">No jobs available at the moment. Please check back later.</p>
  )}
</BannerContainer>

{/*
  const handleJobClick = (id) => {
    navigate(`/jobs/${id}`); // Update to job details route
  };
*/}
  return (
    <Layout>
    <Container className="py-4 px-0">
      <Row className="justify-content-center align-items-start w-100"> 
        <InfoSectionLight
          image={Image}
          id="#"
          title="Job Opportunities"
          text="Discover job opportunities designed to help refugees integrate into the workforce and improve their livelihoods. From local job openings to remote opportunities, explore roles tailored to your skills and interests. Our platform connects you with employers who value diversity and inclusion, ensuring a supportive environment for your growth."
        />
      </Row>
      
      <BannerContainer>
  <BannerHeading>Available Jobs</BannerHeading>

  {Array.isArray(jobs) && jobs.length > 0 ? (
    <Row xs={1} sm={2} md={3} lg={4} xl={3} className="g-4 justify-content-center">
      {jobs.map((job) => (
        <Col key={job._id} className="d-flex justify-content-center">
          <CourseCard className="course-card p-3 border rounded-3 d-flex flex-column h-100">
            <CourseTitle>{job.title}</CourseTitle>
            <CourseDescription>{job.description}</CourseDescription>
            <p><strong>Company:</strong> {job.company}</p>
            <p>
              <strong>Job Link:</strong>{" "}
              <a href={job.link} target="_blank" rel="noopener noreferrer">
                {job.link}
              </a>
            </p>
            <p><strong>Type:</strong> {job.type}</p>
            <p><strong>Requirements:</strong> {job.requirements.join(', ')}</p>
          </CourseCard>
        </Col>
      ))}
    </Row>
  ) : (
    <p className="text-center mt-4">No jobs available at the moment. Please check back later.</p>
  )}
</BannerContainer>

      
    </Container>
  </Layout>
  
  );
};

export default JobsScreen;
